import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink, BookOpen, Globe, Library, ScrollText, GraduationCap, School, FileText, Building2, ShieldCheck } from 'lucide-react';
import { Card } from '../components/ui/card';
import { officialResources } from '../data/features';

const iconMap = { BookOpen, Globe, Library, ScrollText, GraduationCap, School, FileText, Building2 };

export default function ResourcesPage() {
  return (
    <div className="px-4 pt-4 space-y-4">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-emerald-600 font-medium">
        <ArrowLeft size={16} /> ମୁଖ୍ୟ ପେଜ କୁ ଫେରନ୍ତୁ
      </Link>

      <div className="relative overflow-hidden rounded-3xl p-5 text-white shadow-lg"
           style={{ background: 'linear-gradient(135deg, #059669 0%, #0d9488 55%, #0891b2 100%)' }}>
        <div className="absolute -top-8 -right-8 opacity-20"><Library size={110} /></div>
        <Library size={26} />
        <h1 className="text-xl font-extrabold mt-2">ଅଫିସିଆଲ ପାଠ୍ୟ ପୁସ୍ତକ · Official Textbooks</h1>
        <p className="text-xs text-white/90 mt-1">NCERT · SCERT · BSE Odisha · Navodaya (ମାଗଣା ସରକାରୀ ପୋର୍ଟାଲ)</p>
      </div>

      <Card className="rounded-2xl p-3 border-amber-200 bg-amber-50 flex items-start gap-2">
        <ShieldCheck size={16} className="text-amber-600 shrink-0 mt-0.5" />
        <p className="text-[11px] text-amber-800 leading-relaxed">
          <strong>ସୂଚନା:</strong> ସମସ୍ତ ପାଠ୍ୟ ପୁସ୍ତକ ଓ ପ୍ରଶ୍ନପତ୍ର ସରକାରୀ ପୋର୍ଟାଲ ରୁ ମାଗଣା ଉପଲବ୍ଧ। କୌଣସି ପୁସ୍ତକ ଖୋଲିବା ପାଇଁ ତଳ କାର୍ଡକୁ ଟିପନ୍ତୁ।
        </p>
      </Card>

      <div className="grid grid-cols-1 gap-3">
        {officialResources.map((r) => {
          const Icon = iconMap[r.icon] || BookOpen;
          return (
            <a key={r.url} href={r.url} target="_blank" rel="noopener noreferrer"
              className={`relative overflow-hidden rounded-2xl p-4 text-white shadow-md bg-gradient-to-br ${r.color} block hover:scale-[1.01] active:scale-[0.99] transition-transform`}>
              <div className="absolute -top-4 -right-4 opacity-20"><Icon size={70} /></div>
              <div className="relative flex items-start gap-3">
                <div className="w-11 h-11 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center shrink-0">
                  <Icon size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-extrabold text-sm">{r.titleOdia}</div>
                  <div className="text-[11px] text-white/85">{r.title}</div>
                  <div className="text-[10px] text-white/80 mt-1">{r.descOdia} · {r.desc}</div>
                </div>
                <ExternalLink size={16} className="opacity-80 shrink-0 mt-1" />
              </div>
            </a>
          );
        })}
      </div>

      <p className="text-[10px] text-center text-gray-500 pt-2">
        © ସମ୍ପୃକ୍ତ ପୋର୍ଟାଲ ର ପାଠ୍ୟବସ୍ତୁ। Gurusevakendra କେବଳ ଲିଙ୍କ ପ୍ରଦାନ କରୁଛି।
      </p>
    </div>
  );
}
